import { useEffect, useState } from 'react';

import type { Echo, EchoSnapshot } from '../types';

type EchoOkState = { status: 'ok'; echo: Echo; isPreview: boolean };
type EchoErrorState = { status: 'error'; error: unknown };

export type EchoState = EchoOkState | EchoErrorState;
export type SetEchoState = (state: EchoState) => void;

export function useEchoState({ echo, isPreview }: EchoSnapshot): [EchoState, SetEchoState] {
  const [state, setState] = useState<EchoState>({ status: 'ok', echo, isPreview });
  useEffect(() => setState({ status: 'ok', echo, isPreview }), [echo, isPreview, setState]);
  return [state, setState];
}
